module.exports = __webpack_public_path__ + "static/media/logo nti avec fond-min.58509bdd.png";